<template>
  <label :class="labelClass">
    <input :value="option.guid" :checked="active" type="radio" name="payment-method" class="o-radio appearance-none h-4 w-4 border border-gray-200 dark:border-gray-800 rounded-full checked:bg-blue-600 checked:border-blue-600 mt-5" @click="$emit('update:modelValue', option.guid)">

    <div class="w-full px-3 py-3">
      <div class="flex items-center justify-between w-full">
        <div>
          <p class="opacity-90">
            {{ label }}
          </p>
          <p class="opacity-70 text-sm">
            {{ info }}
          </p>
        </div>

        <div>
          <slot />
        </div>
      </div>

      <div v-if="$slots.control && active" class="w-full">
        <slot name="control" :active="active" />
      </div>
    </div>
  </label>
</template>

<script setup lang="ts">
interface Props {
  option?: any
  modelValue?: string | null
  label: string
  info: string
}

const props = withDefaults(defineProps<Props>(), {
  option: null,
  modelValue: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const active = computed(() => {
  return props.option?.guid === props.modelValue
})

const labelClass = computed(() => {
  return 'px-3 flex items-start rounded transition duration-200 mb-2 cursor-pointer border'
})
</script>
